import moment from 'moment';
import util from '@core/services/util';
import ENUMS from '@core/classes/Enums';

function isEmpty(value) {
	if (typeof value === 'undefined' || value === null || value === '') return true;
	else return false;
}

export function validDate(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	const date = moment(value, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss'], true);
	const maximunAllowedDifferenceInYears = 120;

	if (Math.abs(moment().diff(date, 'years')) <= maximunAllowedDifferenceInYears) {
		return date.isValid();
	}

	return false;
}

/** @param {string} value  @returns Boolean, all we need is to check the date is NOT in the future and the format is good.*/
export function validBusinessStartDate(value) {
	if (!value) return true;

	const date = moment(value, 'MM/DD/YYYY', true);

	if (!date.isValid()) {
		return false;
	}

	if (date.isAfter(moment())) {
		return false;
	}
	return true;
}

/**
 * @param {string} value
 * @returns Boolean, only accept value that only contains numbers and letters.
 */
export function validLicense(value) {
	if (typeof value === 'undefined' || value === null || value === '') return true;
	return /^[a-zA-Z0-9]+$/.test(value);
}

export function dateInFuture(mainDate, comparedDate) {
	return util.toMoment(mainDate).startOf('day').isAfter(util.toMoment(comparedDate).startOf('day'));
}

function validInServiceDateForVehicleYear(mainDate, comparedDate, vehicleYear) {
	var earliestDate = util.toMoment(vehicleYear - 1 + '-01-01');
	var latestDate = util.toMoment(vehicleYear + 1 + '-12-31');
	const date = util.toMoment(mainDate);

	return (date.isBefore(latestDate) && date.isAfter(earliestDate)) || date.isSame(earliestDate) || date.isSame(latestDate);
}

export function validInServiceDate(value, comparedDate, vehicleYear) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	return validDate(value) && !dateInFuture(value, comparedDate) && validInServiceDateForVehicleYear(value, comparedDate, vehicleYear);
}

export function validVehicleYear(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	// create a moment for the input year
	const inputYear = moment(value, 'YYYY');

	// checking if the input year is a valid year
	if (!inputYear.isValid()) {
		return false;
	}

	// create a moment for each year limit
	const minYear = moment('1900', 'YYYY');
	const maxYear = moment().startOf('year').add(3, 'years');

	// Checking if year is within the valid range
	return inputYear.isSameOrAfter(minYear) && inputYear.isSameOrBefore(maxYear);
}

export function validVehicleMake(fimenu, storeSettings, makeId) {
	// console.log('validVehicleMake(fimenu, storeSettings, vehicle)', fimenu, storeSettings.vehicleRestrictions, makeId, fimenu.inventoryType, 'isCertified: ' + fimenu.vehicleWarranty.isCertified);
	if (storeSettings.vehicleRestrictions && makeId) {
		const { allowNew, allowNewBrands, allowCPO, allowCPOBrands, allowUsed, allowUsedBrands } = storeSettings.vehicleRestrictions;

		let foundBrand;
		if (fimenu.inventoryType?.toLowerCase() === 'new' && allowNew) {
			if (allowNewBrands?.length == 0) return true;

			foundBrand = allowNewBrands.find(b => b.saturnBrandId == makeId);
		} else if (fimenu.inventoryType?.toLowerCase() === 'used') {
			if (fimenu.vehicleWarranty.isCertified && allowCPO) {
				if (allowCPOBrands?.length == 0) return true;

				foundBrand = allowCPOBrands.find(b => b.saturnBrandId == makeId);
			} else if (!fimenu.vehicleWarranty.isCertified && allowUsed) {
				if (allowUsedBrands?.length == 0) return true;

				foundBrand = allowUsedBrands.find(b => b.saturnBrandId == makeId);
			}
		}

		return foundBrand !== undefined;
	}

	return true;
}

export function validDateOfBirth(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	const dateProvided = moment(value, ['MM/DD/YYYY']);
	return validDate(value) && moment().diff(dateProvided, 'years') >= 18;
}

export function validDriversLicenseExpirationDate(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	var date = moment(value, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss'], true);
	if (!date.isValid()) {
		return true;
	}

	// Compare dates ignoring the time
	return date.diff(moment().startOf('day')) >= 0;
}

export function validVIN(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	var isValid = /^[A-HJ-NPR-Z0-9]{13}[0-9]{4}$/.test(value.toUpperCase());
	return isValid;
}

export function validZIPUS(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	// Full Zip Code xxxxx-xxxx
	//var isValid = /^\d{5}(-\d{4})?$/.test(value);

	// Five Digit Zip Code xxxxx
	var isValid = /^\d{5}$/.test(value);

	return isValid;
}

export function validZIPInternational(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}

	//10 digits Zip Code that can include spaces and or dashes
	var isValid = /^[A-Za-z0-9\s-]+$/.test(value);

	return isValid;
}

export function validSSN(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	var isValid = /^\d{9}$/.test(value);
	return isValid;
}

export function isSSNUsed(ssnHashed, fimenu) {
	if (typeof ssnHashed === 'undefined' || ssnHashed === null || ssnHashed === '') {
		return true;
	}

	let customerSSNs = [fimenu.customer, fimenu.coCustomer].filter(c => !c.isEntity).map(c => c.ssnHashed);
	return customerSSNs.filter(sh => sh == ssnHashed).length == 1;
}

export function validZIPCanada(value) {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	var isValid = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/.test(value);
	return isValid;
}

export function differentFrom(refValue) {
	return value => {
		if (typeof value === 'undefined' || value === null || value === '') {
			return true;
		}
		return value != refValue;
	};
}

export function validSurcharge(refValue) {
	// Validate if the surcharge is visible or not disabled and if the answer is required
	if (refValue.isVisibleInPanel || !refValue.isDisabledInPanel) {
		return refValue.value != null;
	}
	return true;
}

export function transUnionPin(value) {
	return value ? value.length == 6 || value.length == 8 : false;
}

export function validName(value) {
	if (isEmpty(value)) return true;

	if (typeof value != 'string') return false;
	//In the ReGex we're checking if the only have characters from a-z and A-Z. (lower/uppercase). If we do, we it's okay. If we find anything else numbers/special chars, etc; is invalid.
	return value?.length <= 50 && !/[^a-zA-Z-' ]/.test(value);
}

export function validInsuranceEffectiveDate(value) {
	if (isEmpty(value)) return true;

	const maximunAllowedDifferenceInYears = 1;
	const daysFromToday = moment().diff(util.toMoment(value), 'days', true);
	const yearsFromToday = moment().diff(util.toMoment(value), 'years', true);

	return validDate(value) && yearsFromToday < maximunAllowedDifferenceInYears && daysFromToday >= 0;
}

export function validInsuranceExpirationDate(value, effectiveDate) {
	if (isEmpty(value) || isEmpty(effectiveDate)) return true;
	const maximunAllowedDifferenceInYears = 1;
	const daysFromToday = util.toMoment(value).diff(moment(), 'days', true);
	const yearsFromEffectiveDate = util.toMoment(value).diff(moment(effectiveDate), 'years', true);

	return validDate(value) && yearsFromEffectiveDate <= maximunAllowedDifferenceInYears && daysFromToday >= 0;
}
